import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const ApplicationContext = createContext();
export const useApplicationContext = () => useContext(ApplicationContext);

const ApplicationContextProvider = ({ children }) => {
  const [appList, setAppList] = useState([]);

  return (
    <ApplicationContext.Provider
      value={{
        appList,
        setAppList,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export default ApplicationContextProvider;
